

















































































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import QuickTable from "../../../../../components/table/table.vue";
import Tools from '../../../../../lib/tools';
import Appconst from '../../../../../lib/appconst';
@Component({
	name:'qualificationTrain',
	components: {
		QuickTable
	}
})
export default class QualificationTrain extends AbpBase {
	initData:any = {
		showModal: false,
		formLoading: false,
        formData: {
            trainDt: new Date(),
			trainAddress: '',
			trainContent: '',
			host: '',
			trainExpert: '',
			attendee: '',
			meetingSummary: '',
			meetingImages: [],
			meetingAttachs: []
        },
        ruleValidate: {
        	trainDt: [
                { required: true, type: 'date', message: '请选择培训时间', trigger: 'blur' }
            ],
            trainAddress: [
                { required: true, message: '请填写培训地点', trigger: 'blur' }
            ],
            trainContent: [
                { required: true, message: '请填写培训内容（题目）', trigger: 'blur' }
            ],
            host: [
                { required: true, message: '请填写主持人', trigger: 'blur' }
            ],
            attendee: [
                { required: true, message: '请填写参会人', trigger: 'blur' }
            ],
            meetingSummary: [
                { required: true, message: '请填写会议纪要', trigger: 'blur' }
            ],
            meetingImages: [
                { required: true, type: 'array', message: '请上传相关会议照片' }
            ],
            meetingAttachs: [
                { required: true, type: 'array', message: '请上传相关培训材料与会议签到表' }
            ]
        },
		datepickerOption: {
            disabledDate (date:any) {
                return date && date.valueOf() > Date.now();
            }
        },
		columns: [
			{
				title: '序号',
				type: 'index',
				width: 60
			},
			{
				title: '培训时间',
				key: 'trainDt',
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.trainDt));
				}
			},
			{
				title: '培训地点',
				key: 'trainAddress'
			},
			{
				title: '培训内容（题目）',
				key: 'trainContent'
			},
			{
				title: '主持人',
				key: 'host'
			},
			{
				title: '参会人',
				key: 'attendee'
			},
			{
				title: '培训专家',
				key: 'trainExpert'
			},
			/*{
				title: '操作',
				key: 'action'
			}*/
		],		
		fileUrl: Appconst.fileUrl
	}
    //照片上传        
    handleView (url:any) {
        this.initData.previewUrl = url;
        this.initData.previewVisible = true;
    }
    handleSuccess (res:any, file:any) {
    	this.initData.formData.meetingImages.push(res.result);
    }
    handleFormatError (file:any) {
        this.$Notice.warning({
            title: '图片格式错误',
            desc: '图片 ' + file.name + ' 格式错误, 请选择jpg或者png格式的图片'
        });
    }
    handleMaxSize (file:any) {
        this.$Notice.warning({
            title: '图片大小错误',
            desc: '图片 ' + file.name + ' 超过2M限制'
        });
    }
    handleBeforeUpload () {
		if(!this.initData.formData.meetingImages) return;
        const check = this.initData.formData.meetingImages.length < 5;
        if (!check) {
            this.$Notice.warning({
                title: '上传图片数量需小于五张'
            });
        }
        return check;
    }
    // 上传材料
    handleUploadFileSuccess(res:any, file:any) {
    	
    }
    // 新增
    async handleSubmit() {
    	this.initData.formData.meetingAttachs = (this as any).$refs.uploadFile.fileList;
        (this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
            	let params:any = {
            		trainDt: Tools.formatDate(this.initData.formData.trainDt),
					trainAddress: this.initData.formData.trainAddress,
					trainContent: this.initData.formData.trainContent,
					host: this.initData.formData.host,
					trainExpert: this.initData.formData.trainExpert,
					attendee: this.initData.formData.attendee,
					meetingSummary: this.initData.formData.meetingSummary,
					meetingImages: this.initData.formData.meetingImages
            	}
            	// 格式化材料文件
    			params.meetingAttachs = this.initData.formData.meetingAttachs.map((res:any) => {
    				return res.response.result;
    			})
    			
    			this.initData.formLoading = true;
    			// 添加
				await Ajax.post('/api/services/app/SafetyTrain/CreateProductTrainAsync', params).then((res:any)=>{
	                this.$Message.success('提交成功!');
	                this.handleSubmitSuccess();
	            }).catch(() => {
	            	this.initData.formLoading = false;
	            })
            }
        })
    }
    handleSubmitSuccess() {
    	this.initData.formLoading = false;
        this.initData.showModal = false;
        (this as any).$refs.form.resetFields();
    	(this as any).$refs.table.GetData();
    }
    async handleDetailFile(file:any, fileList:any) {
    	this.initData.formData.meetingImages.splice(file.index, 1);
    }
    mounted() {
    	
    }
}
